/* eslint-env browser */

import { Controller } from '@hotwired/stimulus'
import { createConsumer } from '@rails/actioncable'

export default class extends Controller {
  static values = {
    streamChannel: String,
    signedStreamName: String
  }

  connect () {
    this.cable = createConsumer()
    this.#subscribeToChannel()
  }

  disconnect () {
    this.cable.subscriptions.remove(this.stream)
  }

  #subscribeToChannel () {
    this.stream = this.cable.subscriptions.create({
      channel: this.streamChannelValue,
      signed_stream_name: this.signedStreamNameValue
    }, {
      received: this.#handleReceived.bind(this)
    })
  }

  #handleReceived ({ device_id: deviceId, status }) {
    const storedDeviceId = this.#deviceId

    if (storedDeviceId !== deviceId) return

    try {
      switch (status) {
        case 'denied':
        case 'deleted':
          this.#deleteDeviceId()
          break
        case 'allow':
        case 'updated':
          break
      }
    } finally {
      document.location.reload(true)
    }
  }

  get #deviceId () {
    try {
      return localStorage.getItem('deviceId')
    } catch (error) {
      console.warn('Failed to access localStorage:', error)
      return null
    }
  }

  #deleteDeviceId () {
    try {
      localStorage.removeItem('deviceId')
    } catch (error) {
      console.warn('Failed to remove deviceId from localStorage:', error)
    }
  }
}
